class BundleModal {
    constructor() {
      this.modal = document.getElementById('bundleModal');
      this.overlay = document.querySelector('.bundle-modal-overlay');
      this.title = this.modal.querySelector('#bundleModalTitle');
      this.progress = this.modal.querySelector('.bundle-progress');
      this.formProgress = document.querySelector('.bundle-form-progress-bar .bundle-progress');
      this.toggleButtons = this.modal.querySelectorAll('.bundle-product-toggle');
      this.closeButton = this.modal.querySelector('[data-bundle-close]');
      this.selectedProducts = [];
      this.MAX_SELECTIONS = 6;
      this.mainForm = document.querySelector('form[action="/cart/add"]');
      this.addToCartButton = document.querySelector('[data-add-to-cart]');
      this.addToBundleButton = document.querySelector('[data-add-to-bundle]');
      this.originalButtonText = this.addToCartButton ? this.addToCartButton.querySelector('[data-add-to-cart-text]').textContent : '';
      this.originalBundleButtonText = this.addToBundleButton ? this.addToBundleButton.querySelector('[data-add-to-bundle-text]').textContent : '';
      this.bundleSlots = document.querySelectorAll('.bundle-product-slot');
      this.selectedCounter = document.querySelector('.bundle-product-toggle-text-count span');
      this.currentSlot = null;
      this.maxSelectionsElement = document.querySelector('.max-selections');
      this.mainCountTextElement = document.querySelector('.bundle-product-toggle-text-count');
      this.modalCountTextElement = document.querySelector('.bundle-modal-header .bundle-product-toggle-text-count');
      
      // 슬롯별 선택된 제품 추적
      this.slotSelections = {};
      
      this.init();
      this.restoreSelectedState();
      
      // variant 변경 이벤트 리스너 수정
      document.querySelectorAll('[name="options[Option]"]').forEach(radio => {
        radio.addEventListener('change', () => {
          // 선택된 번들 초기화
          this.resetAllSelections();
          // 최대 선택 수 업데이트
          this.updateMaxSelections();
          // 슬롯 표시/숨김 업데이트
          this.updateSlotVisibility();

        });
      });
      
      this.updateMaxSelections();
      this.updateSlotVisibility();
      
      // 제거 버튼 이벤트 리스너 추가
      this.bundleSlots.forEach(slot => {
        const removeButton = slot.querySelector('.bundle-slot-remove');
        if (removeButton) {
          removeButton.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.removeSelection(parseInt(slot.dataset.slot));
          });
        }
      });

      this.headerSlider = new Swiper('.bundle-modal-header .swiper', {
        slidesPerView: 'auto',
        spaceBetween: 10,
        watchSlidesProgress: true
      });

      this.collectionsSlider = new Swiper('.bundle-collections .swiper', {
        slidesPerView: 'auto',
        spaceBetween: 10,
        watchSlidesProgress: true,
        slidesOffsetBefore: 15,
        slidesOffsetAfter: 15
      });

      // 초기 Swiper 설정
      if (this.MAX_SELECTIONS === 6) {
        const swiperContainer = document.querySelector('.bundle-product-toggle-buttons .swiper');
        swiperContainer.closest('.bundle-product-toggle-buttons').classList.remove('grid-4items');
        setTimeout(() => {
          this.bundle_slide = new Swiper(swiperContainer, {
            slidesPerView: 4.5,
            spaceBetween: 10,
            slidesOffsetBefore: 15,
            slidesOffsetAfter: 15,
            mousewheel: true,
            observer: true,
            observeParents: true,
            watchSlidesProgress: true,
            breakpoints: {
              768: {
                slidesOffsetBefore: 20,
                slidesOffsetAfter: 20
              }
            }
          });
        }, 100);
        document.querySelector('.swatch-button-animation').style.left = '50%';
        document.querySelector('.swatch-button-animation').textContent = 'Buy 4 get 2 FREE';
      } else {
        const swiperContainer = document.querySelector('.bundle-product-toggle-buttons .swiper');
        swiperContainer.closest('.bundle-product-toggle-buttons').classList.add('grid-4-items');
        document.querySelector('.swatch-button-animation').style.left = '0';
        document.querySelector('.swatch-button-animation').textContent = 'Buy 3 get 1 FREE';
      }

      // 컬렉션 링크 클릭 이벤트 핸들러 추가
      this.modal.querySelectorAll('.bundle-collections a').forEach(link => {
        link.addEventListener('click', (e) => {
          e.preventDefault();
          this.switchCollection(link.dataset.collectionId);
        });
      });

      // 초기 컬렉션 선택
      this.initializeFirstCollection();

      // 오버레이 클릭 이벤트 핸들러
      this.overlay.addEventListener('click', (e) => {
        // 오버레이 영역을 직접 클릭했을 때만 모달 닫기
        if (e.target === this.overlay && e.currentTarget === this.overlay) {
          this.close();
        }
      });

      
    }

    init() {
      this.toggleButtons.forEach(button => {
        button.addEventListener('click', () => this.toggleProduct(button));
      });

      this.closeButton.addEventListener('click', () => this.close());

      this.addToCartButton.addEventListener('click', (e) => {
        e.preventDefault();
        this.handleSubmit();
        console.log('Adding to cart');
      });

      if (this.addToBundleButton) {
        this.addToBundleButton.addEventListener('click', (e) => {
          e.preventDefault();
          this.open();
        });
      }

      this.modal.querySelectorAll('.bundle-product-card').forEach(card => {
        const variantInput = card.querySelector('input[name="id"]');
        if (variantInput) {
          card.dataset.variantId = variantInput.value;
        }
      });
    }

    restoreSelectedState() {
      this.selectedProducts.forEach(productId => {
        const productCard = this.modal.querySelector(`[data-product-id="${productId}"]`);
        if (productCard) {
          productCard.classList.add('selected');
        }
      });
      this.updateProgress();
      this.updateAddToCartButton();
    }

    updateAddToCartButton() {
      if (this.addToCartButton) {
        const textElement = this.addToCartButton.querySelector('[data-add-to-cart-text]');
        textElement.textContent = this.originalButtonText;
      }
      if (this.addToBundleButton) {
        const textElement = this.addToBundleButton.querySelector('[data-add-to-bundle-text]');
        const selectedCount = this.selectedProducts.length;
        const nextDesignNumber = selectedCount + 1;
        textElement.textContent = `Choose your Design`;
      }
    }

    handleSubmit() {
      const formData = new FormData(this.mainForm);
      const mainVariantId = formData.get('id');
      const quantity = parseInt(formData.get('quantity')) || 1;
      
      // 기존 번들 제품들 제거
      const existingBundles = document.querySelectorAll('[data-bundle-item]');
      if (existingBundles.length > 0) {
        const updates = {};
        existingBundles.forEach(bundle => {
          const lineItemKey = bundle.getAttribute('data-line-item-key');
          if (lineItemKey) {
            updates[lineItemKey] = 0;
          }
        });

        // 기존 번들 제품 제거
        fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ updates })
        })
        .then(response => response.json())
        .then(() => {
          // 새로운 번들 제품 추가
          this.addNewBundleProducts(mainVariantId, quantity);
        })
        .catch(error => {
          console.error('Error removing existing bundles:', error);
        });
      } else {
        // 기존 번들이 없는 경우 바로 새 번들 추가
        this.addNewBundleProducts(mainVariantId, quantity);
      }
    }

    addNewBundleProducts(mainVariantId, quantity) {
      try {
        const addToCartButton = this.mainForm.querySelector('[data-add-to-cart]');
        if (addToCartButton) {
          addToCartButton.classList.add('btn--loading');
        }

        // properties 객체 생성
        const properties = {
          '__history': '[]',
          '__bundle': 'true'
        };
        
        if (Array.isArray(this.selectedProducts)) {
          this.selectedProducts.forEach((productId, index) => {
            if (productId) {
              const productCard = this.modal.querySelector(`[data-product-id="${productId}"]`);
              if (productCard) {
                const sku = productCard.dataset.sku;
                const productImage = productCard.querySelector('.bundle-product-image img');
                const productTitle = productCard.querySelector('.bundle-product-info h3');
                
                properties[`Bundle ${index + 1}`] = productTitle ? productTitle.textContent.trim() : '';
                
                // 이미지 URL에서 _small 제거
                if (productImage && productImage.src) {
                  let imageUrl = productImage.src;
                  // _200x_small.jpg를 .jpg로 변경
                  imageUrl = imageUrl.replace(/_200x_small\.(jpg|jpeg|png|gif)/, '.$1');
                  properties[`_bundle_image_${index + 1}`] = imageUrl;
                } else {
                  properties[`_bundle_image_${index + 1}`] = '';
                }
                
                properties[`_sku${index + 1}`] = sku || '';
              }
            }
          });

          // 남은 슬롯을 빈 값으로 채움
          for (let i = this.selectedProducts.length; i < this.MAX_SELECTIONS; i++) {
            properties[`Bundle ${i + 1}`] = '';
            properties[`_bundle_image_${i + 1}`] = '';
            properties[`_sku${i + 1}`] = '';
          }
        }

        // 기존 폼의 hidden input 업데이트
        Object.entries(properties).forEach(([key, value]) => {
          let input = this.mainForm.querySelector(`input[name="properties[${key}]"]`);
          if (!input) {
            input = document.createElement('input');
            input.type = 'hidden';
            input.name = `properties[${key}]`;
            this.mainForm.appendChild(input);
          }
          input.value = value;
        });

        // FormData를 사용하여 폼 데이터 수집
        const formData = new FormData(this.mainForm);
        const data = {};
        formData.forEach((value, key) => {
          data[key] = value;
        });

        // Ajax 요청으로 카트에 추가
        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            items: [{
              id: parseInt(mainVariantId),
              quantity: quantity,
              properties: properties
            }]
          })
        })
        .then(response => response.json())
        .then(data => {
          if (addToCartButton) {
            addToCartButton.classList.remove('btn--loading');
          }
          // 카트 드로어 열기
          document.dispatchEvent(new CustomEvent('cart:open'));
          console.log('셀렉트 번들 초기화 필요');
        })
        .catch(error => {
          console.error('Error:', error);
          if (addToCartButton) {
            addToCartButton.classList.remove('btn--loading');
          }
        });
      } catch (error) {
        console.error('Error in addNewBundleProducts:', error);
        if (addToCartButton) {
          addToCartButton.classList.remove('btn--loading');
        }
      }
    }

    open() {
      console.log('Opening modal');
      this.modal.hidden = false;
      this.modal.classList.add('bundle-product-modal--open');
      document.body.style.overflow = 'hidden';
      document.body.style.paddingRight = '15px';
      this.overlay.classList.remove('hidden');
      this.restoreSelectedState();

      const slots = this.modal.querySelectorAll('.swiper-wrapper .bundle-product-slot');
      console.log('Total slots found:', slots.length);

      slots.forEach((slot, index) => {
        const title = slot.querySelector('.bundle-slot-title');
        if (title) {
          title.textContent = `Design ${index + 1}`;
        }
      });
    }

    close() {
      console.log('Closing modal');
      this.modal.hidden = true;
      this.modal.classList.remove('bundle-product-modal--open');
      document.body.style.overflow = 'auto';
      document.body.style.paddingRight = '0';
      this.overlay.classList.add('hidden');
      this.updateAddToCartButton();
    }

    updateProgress() {
      const count = this.selectedProducts.length;
      const percentage = (count / this.MAX_SELECTIONS) * 100;
      
      // 두 곳의 카운터 모두 업데이트
      const countText = `<span>${count}</span> of ${this.MAX_SELECTIONS} selected`;
      
      if (this.mainCountTextElement) {
        this.mainCountTextElement.innerHTML = countText;
      }
      
      if (this.modalCountTextElement) {
        this.modalCountTextElement.innerHTML = countText;
      }
      
      if (this.progress) {
        this.progress.style.width = `${percentage}%`;
      }

      if (this.formProgress) {
        this.formProgress.style.width = `${percentage}%`;
      }
    }

    findNextEmptySlot() {
      for (let i = 0; i < this.MAX_SELECTIONS; i++) {
        if (!this.slotSelections[i + 1]) {
          return i + 1;
        }
      }
      return null;
    }

    toggleProduct(button) {
      const productId = button.dataset.productId;
      const productCard = button.closest('.bundle-product-card');
      
      // 항상 첫 번째 빈 슬롯을 찾아서 설정
      this.currentSlot = this.findNextEmptySlot();
      
      if (!this.currentSlot) {
        // 빈 슬롯이 없으면 리턴
        return;
      }
      
      // 새 제품 선택
      this.selectedProducts.push(productId);
      this.slotSelections[this.currentSlot] = productId;
      productCard.classList.add('selected');
      this.updateSelectedSlot(productId);

      // 다음 빈 슬롯으로 자동 이동
      this.currentSlot = this.findNextEmptySlot();
      
      this.updateProgress();
      this.updateCounter();
      this.updateButtonState();
      
      // 모든 슬롯이 채워졌을 때
      if (this.selectedProducts.length === this.MAX_SELECTIONS) {
        const realButton = document.querySelector('.bundle-product-toggle-real');
        const fakeButton = document.querySelector('.bundle-product-toggle-fake');
        
        if (realButton && fakeButton) {
          realButton.style.display = 'block';
          fakeButton.style.display = 'none';
        }
        this.close();
      }
    }

    updateButtonState() {
      const realButton = document.querySelector('.bundle-product-toggle-real');
      const fakeButton = document.querySelector('.bundle-product-toggle-fake');
      const selectedCount = this.selectedProducts.length;
      
      if (selectedCount === this.MAX_SELECTIONS) {
        if (realButton) {
          realButton.style.display = 'block';
          realButton.disabled = false;
        }
        if (fakeButton) {
          fakeButton.style.display = 'none';
        }
      } else {
        if (realButton) {
          realButton.style.display = 'none';
        }
        if (fakeButton) {
          fakeButton.style.display = 'block';
          const textElement = fakeButton.querySelector('[data-add-to-bundle-text]');
          if (textElement) {
            // 단순히 다음 디자인 번호만 표시
            const nextDesignNumber = selectedCount + 1;
            textElement.textContent = `Choose your Design`;
          }
        }
      }
    }

    updateMaxSelections() {
      const selectedOption = document.querySelector('[name="options[Option]"]:checked');
      const oldMax = this.MAX_SELECTIONS;
      
      // variant의 data-bundle-max-items 값 가져오기
      const variantTitle = selectedOption.value;
      const variantOption = document.querySelector(`select[name="id"] option[value="${selectedOption.closest('input').value}"]`);
      
      if (variantOption && variantOption.dataset.bundleMaxItems) {
        this.MAX_SELECTIONS = parseInt(variantOption.dataset.bundleMaxItems) || 4;
      } else {
        // 기존 폴백 로직
        switch(variantTitle) {
          case 'Buy 3 get 1 FREE':
            this.MAX_SELECTIONS = 4;
            break;
          case 'Buy 4 get 2 FREE':
            this.MAX_SELECTIONS = 6;
            break;
          default:
            this.MAX_SELECTIONS = 4;
        }
      }

      // 슬롯 표시/숨김 업데이트
      this.updateSlotVisibility();
      this.updateCounter();

      if (oldMax !== this.MAX_SELECTIONS) {
        this.updateProgress();
        this.updateButtonState();
        
        // Swiper 처리
        const swiperContainer = document.querySelector('.bundle-product-toggle-buttons .swiper');
        
        // 기존 Swiper 인스턴스가 있다면 제거
        if (this.bundle_slide) {
          this.bundle_slide.destroy(true, true);
          this.bundle_slide = null;
        }

        if (this.MAX_SELECTIONS === 6) {
          swiperContainer.closest('.bundle-product-toggle-buttons').classList.remove('grid-4-items');
          // 6개 선택일 때만 Swiper 초기화
          setTimeout(() => {
            this.bundle_slide = new Swiper(swiperContainer, {
              slidesPerView: 4.5,
              spaceBetween: 10,
              slidesOffsetBefore: 15,
              slidesOffsetAfter: 15,
              mousewheel: true,
              observer: true,
              observeParents: true,
              watchSlidesProgress: true,
              breakpoints: {
                768: {
                  slidesOffsetBefore: 20,
                  slidesOffsetAfter: 20
                }
              }
            });
          }, 100);
          document.querySelector('.swatch-button-animation').style.left = '50%';
          document.querySelector('.swatch-button-animation').textContent = 'Buy 4 get 2 FREE';
        } else {
          swiperContainer.closest('.bundle-product-toggle-buttons').classList.add('grid-4-items');
          document.querySelector('.swatch-button-animation').style.left = '0';
          document.querySelector('.swatch-button-animation').textContent = 'Buy 3 get 1 FREE';
        }
      }
    }

    updateSlotVisibility() {
      // 메인 슬롯과 헤더 슬롯 모두 업데이트
      ['', '.bundle-modal-header '].forEach(selector => {
        const slots = document.querySelectorAll(`${selector}.bundle-product-slot`);
        slots.forEach((slot, index) => {
          if (index < this.MAX_SELECTIONS) {
            slot.classList.remove('hidden');
            // 4번째 슬롯(index 3)의 badge 처리
            const badge = slot.querySelector('.bundle-slot-badge');
            if (badge && index === 3) {
              if (this.MAX_SELECTIONS === 6) {
                badge.classList.add('hidden');
              } else {
                badge.classList.remove('hidden');
              }
            }
          } else {
            slot.classList.add('hidden');
          }
        });
      });
    }
    
    updateCounter() {
      const count = this.selectedProducts.length;
      if (this.countTextElement) {
        this.countTextElement.innerHTML = `
          <span>${count}</span> of ${this.MAX_SELECTIONS} selected
        `;
      }
    }

    updateSelectedSlot(productId) {
      const slot = this.bundleSlots[this.currentSlot - 1];
      if (!slot) return;

      const productCard = this.modal.querySelector(`[data-product-id="${productId}"]`);
      if (!productCard) return;

      const content = slot.querySelector('.bundle-slot-content');
      const placeholder = slot.querySelector('.bundle-slot-placeholder');
      const productImage = productCard.querySelector('.bundle-product-image img');
      const title = slot.querySelector('.bundle-slot-title');

      // 이미지 로딩 확인 후 업데이트
      const updateSlotContent = () => {
        const image = content.querySelector('img');
        if (image) {
          image.src = productImage.src;
          image.onload = () => {
            content.classList.remove('hidden');
            placeholder.classList.add('hidden');
            slot.classList.add('selected');
            title.textContent = productImage.alt;
          };
        }
      };

      // 헤더 슬롯도 동일한 방식으로 업데이트
      const headerSlot = this.modal.querySelector(`.bundle-modal-header .bundle-product-slot[data-slot="${this.currentSlot}"]`);
      if (headerSlot) {
        const headerContent = headerSlot.querySelector('.bundle-slot-content');
        const headerPlaceholder = headerSlot.querySelector('.bundle-slot-placeholder');
        const headerImage = headerContent.querySelector('img');
        const headerTitle = headerSlot.querySelector('.bundle-slot-title');
        if (headerImage) {
          headerImage.src = productImage.src;
          headerImage.onload = () => {
            headerContent.classList.remove('hidden');
            headerPlaceholder.classList.add('hidden');
            headerSlot.classList.add('selected');
            headerTitle.textContent = productImage.alt;
          };
        }
      }

      // 약간의 지연 후 업데이트 실행
      setTimeout(() => {
        updateSlotContent();
      }, 50);
    }

    clearSlot(slotNumber) {
      const slot = this.bundleSlots[slotNumber - 1];
      if (!slot) return;

      const content = slot.querySelector('.bundle-slot-content');
      const placeholder = slot.querySelector('.bundle-slot-placeholder');
      const image = content.querySelector('img');
      const title = slot.querySelector('.bundle-slot-title');

      // 이미지 src 초기화
      if (image) {
        image.src = '';
      }
      
      content.classList.add('hidden');
      placeholder.classList.remove('hidden');
      slot.classList.remove('selected');
      title.textContent = `Design ${slotNumber}`;

      // 헤더 슬롯 초기화
      const headerSlot = this.modal.querySelector(`.bundle-modal-header .bundle-product-slot[data-slot="${slotNumber}"]`);
      if (headerSlot) {
        const headerContent = headerSlot.querySelector('.bundle-slot-content');
        const headerPlaceholder = headerSlot.querySelector('.bundle-slot-placeholder');
        const headerImage = headerContent.querySelector('img');
        const headerTitle = headerSlot.querySelector('.bundle-slot-title');

        if (headerImage) {
          headerImage.src = '';
        }
        
        headerContent.classList.add('hidden');
        headerPlaceholder.classList.remove('hidden');
        headerSlot.classList.remove('selected');
        headerTitle.textContent = `Design ${slotNumber}`;
      }
      
      // 슬롯 선택 정보 제거
      delete this.slotSelections[slotNumber];
    }

    // 새로운 메서드: 모든 선택 초기화
    resetAllSelections() {
      this.selectedProducts = [];
      this.slotSelections = {};
      
      // 모든 슬롯 초기화
      this.bundleSlots.forEach((slot, index) => {
        this.clearSlot(index + 1);
        slot.classList.remove('selected');
      });

      // 모달 내 선택된 제품 카드 초기화
      this.modal.querySelectorAll('.bundle-product-card.selected').forEach(card => {
        card.classList.remove('selected');
      });

      // 버튼 상태 초기화
      const realButton = document.querySelector('.bundle-product-toggle-real');
      const fakeButton = document.querySelector('.bundle-product-toggle-fake');
      
      if (realButton && fakeButton) {
        realButton.style.display = 'none';
        fakeButton.style.display = 'block';
        fakeButton.querySelector('[data-add-to-bundle-text]').textContent = 'Choose your colours first';
      }

      // 카운터와 프로그레스 업데이트
      this.updateCounter();
      this.updateProgress();
      this.updateButtonState();
    }

    // 새로운 메서드: 선택 제거
    removeSelection(slotNumber) {
      const productId = this.slotSelections[slotNumber];
      if (productId) {
        // 선택된 제품 배열에서 제거
        const index = this.selectedProducts.indexOf(productId);
        if (index > -1) {
          this.selectedProducts.splice(index, 1);
        }
        
        // 슬롯 초기화
        this.clearSlot(slotNumber);
        
        // 모달 내 제품 카드 선택 상태 업데이트
        const productCard = this.modal.querySelector(`[data-product-id="${productId}"]`);
        if (productCard) {
          productCard.classList.remove('selected');
        }
        
        // 현재 슬롯을 비워진 슬롯으로 설정
        this.currentSlot = slotNumber;
        
        // UI 업데이트
        this.updateProgress();
        this.updateCounter();
        this.updateButtonState();
        this.updateAddToCartButton();
      }
    }

    

    // 컬렉션 전환 메서드 추가
    switchCollection(collectionId) {
      // 모든 그리드 숨기기
      this.modal.querySelectorAll('.bundle-products-grid').forEach(grid => {
        grid.classList.add('hidden');
      });

      // 선택된 컬렉션의 그리드만 표시
      const selectedGrid = this.modal.querySelector(`.bundle-products-grid[data-collection-id="${collectionId}"]`);
      if (selectedGrid) {
        selectedGrid.classList.remove('hidden');
      }

      // 활성 링크 스타일 업데이트
      this.modal.querySelectorAll('.bundle-collections a').forEach(link => {
        if (link.dataset.collectionId === collectionId) {
          link.classList.add('active');
        } else {
          link.classList.remove('active');
        }
      });
    }

    // 첫 번째 컬렉션 초기화 메서드 추가
    initializeFirstCollection() {
      const firstCollectionLink = this.modal.querySelector('.bundle-collections a');
      if (firstCollectionLink) {
        const firstCollectionId = firstCollectionLink.dataset.collectionId;
        this.switchCollection(firstCollectionId);
      }
    }

    openModal(slotNumber) {
      this.currentSlot = slotNumber;
      this.modal.classList.add('active');
      document.body.style.overflow = 'hidden';
      
      // 모달이 열릴 때마다 첫 번째 컬렉션 선택
      this.initializeFirstCollection();

      console.log('Modal opened with slot number:', slotNumber);

      // 모든 슬롯의 타이틀 초기화
      const allSlots = this.modal.querySelectorAll('.swiper-slide.bundle-product-slot');
      console.log('Found slots:', allSlots.length);

      allSlots.forEach((slot, index) => {
        const title = slot.querySelector('.bundle-slot-title');
        const dataSlot = slot.getAttribute('data-slot');
        console.log('Processing slot:', {
          index: index,
          dataSlot: dataSlot,
          hasTitle: !!title,
          currentTitle: title ? title.textContent : null
        });

        if (title) {
          title.textContent = `Design ${index + 1}`;
          console.log('Updated title to:', title.textContent);
        }
      });

      // 업데이트 후 최종 상태 확인
      const finalTitles = Array.from(this.modal.querySelectorAll('.bundle-slot-title')).map(t => t.textContent);
      console.log('Final titles:', finalTitles);

      // 선택된 제품들의 상태 복원
      Object.entries(this.selectedProducts).forEach(([slot, product]) => {
        this.updateSlot(slot, product);
      });
    }

  
    updateSlot(slotNumber, product = null) {
      const slot = this.modal.querySelector(`.bundle-product-slot[data-slot="${slotNumber}"]`);
      if (!slot) return;

      const placeholder = slot.querySelector('.bundle-slot-placeholder');
      const content = slot.querySelector('.bundle-slot-content');
      const img = content.querySelector('img');
      const title = slot.querySelector('.bundle-slot-title');

      if (product) {
        // 제품이 선택된 경우
        placeholder.classList.add('hidden');
        content.classList.remove('hidden');
        img.src = product.image;
        img.alt = product.title;
        slot.classList.add('selected');
      } else {
        // 제품이 선택 해제된 경우
        placeholder.classList.remove('hidden');
        content.classList.add('hidden');
        img.src = '';
        img.alt = '';
        slot.classList.remove('selected');
        // title 원상복구
        if (title) {
          title.textContent = `Design ${slotNumber}`;
        }
      }

      // 선택된 상태 저장
      if (product) {
        this.selectedProducts[slotNumber] = product;
      } else {
        delete this.selectedProducts[slotNumber];
      }

      this.updateProgress();
    }
  }

  function openBundleModal(slotNumber) {
    if (window.bundleModal) {
      window.bundleModal.currentSlot = slotNumber;
      window.bundleModal.open();
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    console.log('DOM loaded, initializing BundleModal');
    window.bundleModal = new BundleModal();
  });

  const bundle_collections_slide = new Swiper('.bundle-collections .swiper', {
    slidesPerView: "auto",
    spaceBetween: 8,
    slidesOffsetBefore: 15,
    slidesOffsetAfter: 15,
    breakpoints: {
      768: {
        slidesOffsetBefore: 20,
        slidesOffsetAfter: 20
      }
    }
  });

  function checkInventory(variantId, quantity) {
    const productCard = document.querySelector(`[data-variant-id="${variantId}"]`);
    if (!productCard) return false;
    
    const inventoryQuantity = parseInt(productCard.dataset.inventoryQuantity);
    if (isNaN(inventoryQuantity)) return true; // 재고 관리를 하지 않는 경우
    
    return inventoryQuantity >= quantity;
  }

  // 상품을 선택할 때 재고 확인
  function handleProductSelection(productId, variantId) {
    try {
      if (!checkInventory(variantId, 1)) {
        alert('This item is out of stock');
        return false;
      }
      
      // 첫 번째 빈 슬롯을 찾아서 설정
      const currentSlot = this.findNextEmptySlot();
      
      if (!currentSlot) {
        // 빈 슬롯이 없으면 리턴
        return false;
      }
      
      // 새 제품 선택
      this.selectedProducts.push(productId);
      this.slotSelections[currentSlot] = productId;
      
      const productCard = document.querySelector(`[data-product-id="${productId}"]`);
      if (productCard) {
        productCard.classList.add('selected');
      }
      
      this.updateSelectedSlot(productId);

      // 다음 빈 슬롯으로 자동 이동
      this.currentSlot = this.findNextEmptySlot();
      
      this.updateProgress();
      this.updateCounter();
      this.updateButtonState();
      
      // 모든 슬롯이 채워졌을 때
      if (this.selectedProducts.length === this.MAX_SELECTIONS) {
        const realButton = document.querySelector('.bundle-product-toggle-real');
        const fakeButton = document.querySelector('.bundle-product-toggle-fake');
        
        if (realButton && fakeButton) {
          realButton.style.display = 'block';
          fakeButton.style.display = 'none';
        }
        this.close();
      }
      
      return true;
    } catch (error) {
      console.error('Error in product selection:', error);
      return false;
    }
  }

